import * as Yup from 'yup';

export const forgotPasswordSchema = () => {
    return (
        Yup.object({
            email: Yup.string()
                .trim()
                .required('Email is required')
                .email('Enter a valid email address'),
            captcha: Yup.string().required('Please complete the CAPTCHA'),
        })
    );
}
